import { EquipmentItemViewModel } from "../../../../../../../generated/data-contracts";
import {
  IBlankMediaTypeSectionBase,
  ResCallback,
} from "../../../../../../../models";
import { IAvisEditableListFieldConfig } from "../../../../../../shared/components/editableList";
import {
  AvisDropdown,
  AvisInputText,
} from "../../../../../../shared/components/inputs";

export const fieldCollectionEquipmentAndCNCode = <
  T extends IBlankMediaTypeSectionBase,
>(
  equipments: EquipmentItemViewModel[] | undefined,
  res: ResCallback,
  disabled: boolean | undefined,
): IAvisEditableListFieldConfig<T>[] => {
  return [
    {
      name: "equipmentId",
      title: res("blankMedia_Application_label_Equipment"),
      required: true,
      minWidth: 250,
      width: 250,
      transformViewValue: (fieldValue) => {
        return (
          equipments?.filter((item) => item.id == fieldValue)?.[0]?.name ?? ""
        );
      },
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisDropdown<EquipmentItemViewModel>
            name={`${prefix}.${i}.${String(field.name)}`}
            className="equipment-dropdown"
            onChange={onChange}
            options={equipments}
            optionValue="id"
            optionLabel="name"
            value={val[field.name]}
            hideClear
            required={field.required}
            disabled={disabled}
          />
        );
      },
    },
    {
      name: "cnCode",
      title: res("blankMedia_Application_label_CNCode"),
      description: res("blankMedia_Application_label_CNCodeDescription"),
      minWidth: 120,
      width: 120,
      maxWidth: 120,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputText
            name={`${prefix}.${i}.${String(field.name)}`}
            value={val.cnCode}
            onChange={onChange}
            hideClear
            disabled={disabled}
            maxLength={20}
          />
        );
      },
    },
  ];
};
